export class GeneralModel {
    value1: string = null;
    value2: string = null;
    value3: string = null;
    value4: string = null;
}